export default __webpack_public_path__ + "static/media/guardian-logo.7083c509.svg";